<template>
  <div class="after-purchase">
    <h2 class="after-purchase__title">Dopo l’acquisto…</h2>
    <pointer-list :steps="steps" />
  </div>
</template>

<script>
  import { VALIDITY_MONTHS } from '@livegift/resources';

  export default {
    name: 'after-purchase',

    data() {
      return {
        // cosa succede dopo la conferma dell'ordine (testi dal Figma)
        steps: [
          { title: `Ricevi la card: Controlla la tua email con le istruzioni per l’utilizzo.` },
          { title: `Scegli quando viaggiare: Usala quando preferisci (hai ${VALIDITY_MONTHS} mesi di tempo).` },
          { title: 'Scegli dove andare: In base al servizio scelto, cerca la tua prossima meta.' },
          { title: 'Parti senza pensieri: ...e goditi il tuo acquisto!' },
        ],
      };
    },
  };
</script>

<style lang="scss" scoped>

  .after-purchase {

    // barra accento a sinistra del titolo
    &__title {
      display: flex;
      align-items: center;
      margin: 0 0 ($grid-gutter-width / 2);
      font-size: $font-size-lg;
      font-weight: $vb-font-weight-semibold;
      letter-spacing: .45px;
      color: $gray-900;
      text-transform: uppercase;

      &::before {
        flex-shrink: 0;
        width: 4px;
        height: 15px;
        margin-right: 8px;
        content: '';
        background-color: $primary;
        border-radius: $rounded-pill;
      }
    }
  }
</style>